export const ROUTES = [
  {
    path: '',
    loadChildren: () => import('@fscd-intake/ui/application').then((module) => module.FscdIntakeModule),
  },
];
